import { useEffect, useState } from "react";
import { Pencil, Trash2 } from "lucide-react";
import {
  getApis,
  createApi,
  updateApi,
  deleteApi,
} from "../../services/apiService";
import "../../styles/settings/ApiManagement.css";

const ApiManagement = () => {
  const [apis, setApis] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingApi, setEditingApi] = useState(null);

  const [apiName, setApiName] = useState("");
  const [apiUrl, setApiUrl] = useState("");
  const [messageLimit, setMessageLimit] = useState("");

  const [activeTab, setActiveTab] = useState("OPENAI");

  /* LOAD APIS */
  useEffect(() => {
  loadApis();
}, [activeTab]);

  const loadApis = async () => {

  const res = await getApis(activeTab);

  setApis(res.data);
};

  /* OPEN ADD */
  const openAdd = () => {
    setEditingApi(null);
    setApiName("");
    setApiUrl("");
    setMessageLimit("");
    setShowModal(true);
  };

  /* OPEN EDIT */
  const openEdit = (api) => {
    setEditingApi(api);
    setApiName(api.api_name);
    setApiUrl(api.api_key);
    setMessageLimit(api.message_limit);
    setShowModal(true);
  };

  /* SAVE */
  const handleSave = async () => {
    const payload = {
  api_name: apiName,
  api_key: apiUrl,
  api_type: activeTab,
  message_limit: Number(messageLimit),
};

    if (editingApi) {
      await updateApi(editingApi.api_id, payload);
    } else {
      await createApi(payload);
    }

    setShowModal(false);
    loadApis();
  };

  /* DELETE */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this API?")) return;
    await deleteApi(id);
    loadApis();
  };

  return (
    <div className="settings-page">
      {/* ✅ COMMON SETTINGS HEADER */}
      <div className="settings-header">
        <h2>API Management</h2>
        <button className="add-btn" onClick={openAdd}>
          + Add New API
        </button>
      </div>

      <div className="api-tabs">

  <button
    className={activeTab === "OPENAI" ? "active" : ""}
    onClick={() => setActiveTab("OPENAI")}
  >
    OpenAI APIs
  </button>

  <button
    className={activeTab === "GEMINI" ? "active" : ""}
    onClick={() => setActiveTab("GEMINI")}
  >
    Gemini APIs
  </button>

</div>
      {/* ✅ COMMON SETTINGS TABLE */}
      <table className="settings-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>API Key</th>
            <th>Message Limit</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {apis.map((api, index) => (
            <tr key={api.api_id}>
              <td>{index + 1}</td>
              <td>{api.api_name}</td>
              <td className="api-key">{api.api_key}</td>
              <td>{api.message_limit}</td>

              <td>
                <button
                  className="action-btn"
                  onClick={() => openEdit(api)}
                  title="Edit"
                >
                  <Pencil size={16} />
                </button>

                <button
                  className="action-btn delete"
                  onClick={() => handleDelete(api.api_id)}
                  title="Delete"
                >
                  <Trash2 size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* MODAL (UNCHANGED) */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>API Configuration</h3>

            <label>API Name</label>
            <input
              value={apiName}
              onChange={(e) => setApiName(e.target.value)}
            />

            <label>API KEY</label>
            <input
              value={apiUrl}
              onChange={(e) => setApiUrl(e.target.value)}
            />

            <label>Message Limit</label>
            <input
              type="number"
              value={messageLimit}
              onChange={(e) => setMessageLimit(e.target.value)}
            />

            <div className="modal-actions right">
              <button
                className="secondary-btn"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button className="primary-btn" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApiManagement;
